import React, {useEffect, useLayoutEffect, useRef, useState} from 'react';
import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../../redux/hooks";
import {Toast} from "primereact/toast";
import {setStatusesByPeriodClearFilters, setStatusesByPeriodCurrentPage, setStatusesByPeriodCurrentPageSize, setStatusesByPeriodFilter, setStatusesByPeriodUiFilters} from "../../../redux/actions/actionsStatusesByPeriodList";
import {
    areSearchParamsEqual,
    buildPeriodStatusesSearchParams,
    readInitialPeriodStatusesUrlState
} from "../../../utils/periodStatusesUrlState";
import {getStatusesDictionary} from "../../../redux/api/apiStatusesList";
import {getUserStatuses} from "../../../redux/api/apiUsersList";
import {StatusByPeriodDataSort} from "../../../types/types";
import {Button} from "primereact/button";
import {classNames} from "primereact/utils";
import {MultiSelect} from "primereact/multiselect";
import {Dropdown} from "primereact/dropdown";
import {Badge} from "primereact/badge";
import StatusesByPeriodListNav from "./StatusesByPeriodListNav";
import StatusesByPeriodDetails from "./StatusesByPeriodDetails";
import {DataTable} from "primereact/datatable";
import {Column, ColumnFilterElementTemplateOptions} from "primereact/column";
import {Paginator} from "primereact/paginator";
import {Dialog} from "primereact/dialog";
import BranchDialog from "../../Branch/BranchDialog";
import {Calendar} from "primereact/calendar";
import {getStatusesByPeriodWithPaginationFilterAndSorting} from "../../../redux/api/apiStatusesByPeriodList";
import {GET_STATUSES_BY_PERIOD_LIST} from "../../../redux/types/typesStatusesByPeriodList";

const StatusesByPeriodList = (props: any) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [initialPeriodStatusesUrlState] = useState(readInitialPeriodStatusesUrlState);
    const persistChildWindow = initialPeriodStatusesUrlState.childWindow;
    const dispatch = useAppDispatch();
    const clearFilters = useAppSelector(state => state.StatusesByPeriodListReducer.clearFilters);
    const statusesByPeriodList = useAppSelector(state => state.StatusesByPeriodListReducer.statusesByPeriodList);
    const pagination = useAppSelector(state => state.StatusesByPeriodListReducer.pagination);
    const paginationPage = useAppSelector(state => state.StatusesByPeriodListReducer.paginationPage);
    const paginationSize = useAppSelector(state => state.StatusesByPeriodListReducer.paginationSize);
    const loader = useAppSelector(state => state.StatusesByPeriodListReducer.loading);
    const statusesDictionary = useAppSelector(state => state.StatusesListReducer.statusesDictionary);
    const statusesList = useAppSelector(state => state.UsersListReducer.statuses);
    const [visible, setVisible] = useState<boolean>(false);
    const toast = useRef<Toast>(null);
    const [first, setFirst] = useState(() => (initialPeriodStatusesUrlState.page - 1) * initialPeriodStatusesUrlState.size);
    const [hasStartFilter, setHasStartFilter] = useState<boolean>(
        !!(initialPeriodStatusesUrlState.hasStartFilter && initialPeriodStatusesUrlState.userName)
    );
    const useUrlPageOnStartRef = useRef(
        !!(initialPeriodStatusesUrlState.hasStartFilter && initialPeriodStatusesUrlState.userName && initialPeriodStatusesUrlState.page !== 1)
    );
    const [hasEndFilter, setHasEndFilter] = useState<boolean>(false);
    const [totalItems, setTotalItems] = useState<number>(paginationSize);
    const hasInitializedPagination = useRef(false);
    const skipUrlWriteRef = useRef(true);
    const [tableMountKey, setTableMountKey] = useState(0);
    const [data] = useState<any>(null);
    const [orderBy, setOrderBy] = useState<any>(initialPeriodStatusesUrlState.orderBy);
    const [isDescFilter, setIsDescFilter] = useState<boolean>(initialPeriodStatusesUrlState.isDesc);
    const [filterStatusesId, setFilterStatusesId] = useState<any>(initialPeriodStatusesUrlState.filterStatusesId);
    const [filterTypeId, setFilterTypeId] = useState<any>(null);
    const [filterStatusName, setFilterStatusName] = useState<any>(null);
    const [filterStatusId, setFilterStatusId] = useState<any>(null);
    const [filterStatusIds, setFilterStatusIds] = useState<any>(initialPeriodStatusesUrlState.filterStatusIds);
    const [filterChangeType, setFilterChangeType] = useState<any>(initialPeriodStatusesUrlState.filterChangeType);
    const [sortOrder, setSortOrder] = useState<number>(initialPeriodStatusesUrlState.sortOrder);
    const [page, setPage] = useState<any>(initialPeriodStatusesUrlState.page);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [selectedRowData, setSelectedRowData] = useState<any | null>(null);
    const [selectedRowExpansion, setSelectedRowExpansion] = useState<any | null>(null);
    const [duration] = useState<boolean>(false);
    const jwtToken = useAppSelector(state => state.UsersReducer.userData.jwtToken);
    const [durationStartTime, setdurationStartTime] = useState<any>(getDefaultStartTime());
    const [durationEndTime, setdurationEndTime] = useState<any>(getDefaultStartTime());
    const [timeInStatusStartTime, setTimeInStatusStartTime] = useState<any>(initialPeriodStatusesUrlState.timeInStatusStartTime || getDefaultStartTime());
    const [timeInStatusEndTime, setTimeInStatusEndTime] = useState<any>(initialPeriodStatusesUrlState.timeInStatusEndTime || getDefaultStartTime());
    const [hasTimeInStatusFilter, setHasTimeInStatusFilter] = useState<boolean>(false);
    const justAppliedTimeInStatusFilter = useRef<boolean>(false);
    const timeInStatusFilterRequestSent = useRef<boolean>(false);
    const [isFinishDateFocused, setIsFinishDateFocused] = useState<boolean>(false);
    const [isFinishEndDateFocused, setIsFinishEndDateFocused] = useState<boolean>(false);
    const [filterDateTime, setFilterDateTime] = useState<any>(initialPeriodStatusesUrlState.filterDateTime || false);
    const [filterEndDateTime, setFilterEndDateTime] = useState<any>(initialPeriodStatusesUrlState.filterEndDateTime || false);
    const [filterFinishDateTime, setFilterFinishDateTime] = useState<any>(initialPeriodStatusesUrlState.filterFinishDateTime || false);
    const [filterFinishEndDateTime, setFilterFinishEndDateTime] = useState<any>(initialPeriodStatusesUrlState.filterFinishEndDateTime || false);
    const [startTime, setStartTime] = useState<any>(initialPeriodStatusesUrlState.startTime || null);
    const [endTime, setEndTime] = useState<any>(initialPeriodStatusesUrlState.endTime || null);
    const [startFinishTime, setStartFinishTime] = useState<any>(initialPeriodStatusesUrlState.startFinishTime || null);
    const [endFinishTime, setEndFinishTime] = useState<any>(initialPeriodStatusesUrlState.endFinishTime || null);
    const [isStartDateFocused, setIsStartDateFocused] = useState<boolean>(false);
    const [isEndDateFocused, setIsEndDateFocused] = useState<boolean>(false);
    const [isStartFinishTimeFocused, setIsStartFinishTimeFocused] = useState<boolean>(false);
    const [isEndFinishTimeFocused, setIsEndFinishTimeFocused] = useState<boolean>(false);
    const [activity, setActivity] = useState<boolean>(false);
    const [allTimeChecked, setAllTimeChecked] = useState<boolean>(false);
    const [selectedUser, setSelectedUser] = useState<any>(initialPeriodStatusesUrlState.userName);
    const [selectedBranchId, setSelectedBranchId] = useState<number | null>(initialPeriodStatusesUrlState.branchId);
    const activityChangedManuallyRefStatus = useRef<boolean>(false);
    const [sortData, setSortData] = useState<any>({
        pageNumber: page ? page : paginationPage,
        pageSize: paginationSize,
        sort: {
            orderBy: orderBy ? orderBy : "Id",
            isDesc: isDescFilter
        }
    });

    function getDefaultStartTime(): Date {
        const d = new Date();
        d.setHours(0, 0, 0, 0);
        return d;
    }

    const activeClick = useAppSelector(state => state.UsersListReducer.activeClick);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (pagination.hasNext && pagination.pageNumber) {
            setTotalItems((pagination.pageNumber * paginationSize) + paginationSize)
        } else if (!pagination.hasNext) {
            setTotalItems(pagination.pageNumber * paginationSize);
        }
    }, [pagination]);

    useEffect(() => {
        setTotalItems((pagination.pageNumber * paginationSize) + paginationSize);
    }, [])

    useEffect(() => {
        if (!initialPeriodStatusesUrlState.hasAny) {
            dispatch(setStatusesByPeriodCurrentPageSize(10));
            dispatch(setStatusesByPeriodCurrentPage(1));
        }
        dispatch(getStatusesDictionary(jwtToken?.jwtToken));
        dispatch(getUserStatuses(jwtToken?.jwtToken));
    }, []);

    useEffect(() => {
        if (initialPeriodStatusesUrlState.filterDateTime && initialPeriodStatusesUrlState.filterEndDateTime) {
            return;
        }
        setStartTime(new Date("2024-10-29 00:00:00"));
        setEndTime(() => {
            const d = new Date();
            d.setHours(23, 59, 59, 0);
            return d;
        });
        setFilterDateTime(new Date());
        setFilterEndDateTime(new Date());
    }, []);

    useLayoutEffect(() => {
        if (initialPeriodStatusesUrlState.hasAny) {
            if (Object.keys(initialPeriodStatusesUrlState.uiFilters || {}).length > 0) {
                dispatch(setStatusesByPeriodUiFilters(initialPeriodStatusesUrlState.uiFilters));
            } else {
                dispatch(setStatusesByPeriodClearFilters());
            }
            if (initialPeriodStatusesUrlState.page !== 1) {
                dispatch(setStatusesByPeriodCurrentPage(initialPeriodStatusesUrlState.page));
            }
            if (initialPeriodStatusesUrlState.size !== 10) {
                dispatch(setStatusesByPeriodCurrentPageSize(initialPeriodStatusesUrlState.size));
            }
            setTableMountKey(1);
            return;
        }

        dispatch(setStatusesByPeriodClearFilters());
        setTableMountKey(1);
    }, []);

    useEffect(() => {
        const period = (location.state as { period?: { filterDateTime?: Date; filterEndDateTime?: Date; startTime?: Date; endTime?: Date } })?.period;
        if (period) {
            if (period.filterDateTime != null) setFilterDateTime(period.filterDateTime);
            if (period.filterEndDateTime != null) setFilterEndDateTime(period.filterEndDateTime);
            if (period.startTime != null) setStartTime(period.startTime);
            if (period.endTime != null) setEndTime(period.endTime);
            setHasStartFilter(true);
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, [location.state]);


    function getDefaultStartDate(): Date {
        return new Date();
    }

    function getDefaultEndDate(): Date {
        return new Date();
    }

    function getDefaultEndTime(): Date {
        const d = new Date();
        d.setHours(23, 59, 59, 0);
        return d;
    }

    const formatDateTime = (dateString: any) => {
        const date = new Date(dateString);
        return `${date.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit', second: '2-digit'})} ${date.toLocaleDateString('en-GB')}`;
    };

    const formatDate = (dateString: Date) => {
        const dateObj = new Date(dateString);
        const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
        const day = dateObj.getDate().toString().padStart(2, "0");
        const year = dateObj.getFullYear();
        return `${month}/${day}/${year}`;
    };

    const applyBranchIdToDataSort = (dataSort: StatusByPeriodDataSort) => {
        if (selectedBranchId != null) {
            dataSort.branchId = selectedBranchId;
        }
        return dataSort;
    };

    const getTime = (dateString: Date | any, isEnd?: boolean) => {
        const dateObj = new Date(dateString);
        const hours = dateObj.getHours().toString().padStart(2, "0");
        const minutes = dateObj.getMinutes().toString().padStart(2, "0");
        const seconds = dateObj.getSeconds().toString().padStart(2, "0");
        return `${hours}:${minutes}:${seconds}`;
    };

    const resetTableHorizontalScroll = () => {
        const scrollableBody = document.querySelector('.p-datatable-wrapper');
        if (scrollableBody) {
            scrollableBody.scrollTop = 0;
            scrollableBody.scrollLeft = 0;
        }
    };

    useEffect(() => {
        dispatch({type: GET_STATUSES_BY_PERIOD_LIST, payload: null})
    }, []);

    useEffect(() => {
        if (hasInitializedPagination.current) {
            dispatch(setStatusesByPeriodCurrentPage(1));
            setFirst(0);
            setPage(1);
        }
    }, [filterStatusesId, filterStatusName, filterStatusId, filterTypeId, filterChangeType, filterStatusIds, selectedUser]);

    useEffect(() => {
        if (!hasInitializedPagination.current) {
            hasInitializedPagination.current = true;
            const urlPage = initialPeriodStatusesUrlState.page || 1;
            const urlSize = initialPeriodStatusesUrlState.size || 10;
            const pageChanged = paginationPage !== urlPage;
            const sizeChanged = paginationSize !== urlSize;
            if (pageChanged) {
                dispatch(setStatusesByPeriodCurrentPage(urlPage));
            }
            if (sizeChanged) {
                dispatch(setStatusesByPeriodCurrentPageSize(urlSize));
            }
            if (pageChanged || sizeChanged) {
                return;
            }
        }
        if (!jwtToken?.jwtToken) {
            return;
        }

        setSelectedRowData(null);
        let filter: { key: string; value: string }[] = [];
        const dataSort: StatusByPeriodDataSort = {
            pageNumber: page ? page : paginationPage,
            pageSize: paginationSize,
            sort: {
                orderBy: orderBy ? orderBy : "TimeStart",
                isDesc: isDescFilter
            }
        }

        if (filterStatusesId?.value) {
            filter.push(filterStatusesId);
        }
        if (filterStatusName?.value) {
            filter.push(filterStatusName);
        }
        if (filterStatusIds) {
            filterStatusIds.map((item: any) => {
                filter.push(item);
            })
        }
        if (filterTypeId) {
            filterTypeId.map((item: any) => {
                filter.push(item);
            })
        }
        if (filterStatusId) {
            dataSort.active = filterStatusId?.value
        }

        if (filterChangeType?.value) {
            filter.push(filterChangeType);
        }

        if (selectedUser) {
            filter.push({
                key: "UserName",
                value: typeof selectedUser === 'string' ? selectedUser : selectedUser.userName
            });
        }

        if (filterDateTime && filterEndDateTime && startTime && endTime) {
            let startDate = formatDate(filterDateTime);
            let endDate = formatDate(filterEndDateTime);
            let filterStartTime = getTime(startTime);
            let filterEndTime = getTime(endTime);
            filter.push({
                key: "TimeStart",
                value: `${startDate} ${filterStartTime},${endDate} ${filterEndTime}`
            });
        }

        if (filterFinishDateTime && filterFinishEndDateTime && startFinishTime && endFinishTime) {
            let startDate = formatDate(filterFinishDateTime);
            let endDate = formatDate(filterFinishEndDateTime);
            let filterStartTime = getTime(startFinishTime);
            let filterEndTime = getTime(endFinishTime);
            filter.push({
                key: "TimeEnd",
                value: `${startDate} ${filterStartTime},${endDate} ${filterEndTime}`
            });
        }

        if (timeInStatusStartTime && timeInStatusEndTime &&
            (!isDefaultTime(timeInStatusStartTime) || !isDefaultTime(timeInStatusEndTime))) {
            const startSeconds = getTotalSeconds(timeInStatusStartTime);
            const endSeconds = getTotalSeconds(timeInStatusEndTime);
            if (startSeconds !== null && endSeconds !== null) {
                filter.push({
                    key: 'TimeInStatus',
                    value: `${startSeconds},${endSeconds}`
                });
            }
        }

        if (filter.length > 0) {
            dataSort['filter'] = filter;
        }

        applyBranchIdToDataSort(dataSort);

        resetTableHorizontalScroll();

        if (!hasStartFilter && !hasEndFilter && !hasTimeInStatusFilter &&
            !justAppliedTimeInStatusFilter.current && !timeInStatusFilterRequestSent.current && !!selectedUser) {
            dispatch(getStatusesByPeriodWithPaginationFilterAndSorting(dataSort, jwtToken?.jwtToken));
            dispatch(setStatusesByPeriodFilter(dataSort));
            setPage(null);
            setSortData(dataSort);
        }
    }, [paginationPage, paginationSize, data, orderBy, isDescFilter, filterStatusesId, filterStatusName, filterStatusId, filterTypeId, filterChangeType, filterStatusIds, jwtToken?.jwtToken]);

    useEffect(() => {
        if (skipUrlWriteRef.current) {
            skipUrlWriteRef.current = false;
            return;
        }

        const userName = selectedUser
            ? (typeof selectedUser === 'string' ? selectedUser : selectedUser.userName)
            : null;

        const nextParams = buildPeriodStatusesSearchParams({
            page: paginationPage,
            size: paginationSize,
            orderBy,
            isDesc: isDescFilter,
            sortOrder,
            userName,
            branchId: selectedBranchId,
            childWindow: persistChildWindow,
            filterStatusesId,
            filterStatusIds,
            filterChangeType,
            filterDateTime,
            filterEndDateTime,
            startTime,
            endTime,
            filterFinishDateTime,
            filterFinishEndDateTime,
            startFinishTime,
            endFinishTime,
            hasEndFilter: !!(filterFinishDateTime && filterFinishEndDateTime && startFinishTime && endFinishTime),
            timeInStatusStartTime,
            timeInStatusEndTime,
        });

        if (!areSearchParamsEqual(searchParams, nextParams)) {
            setSearchParams(nextParams, {replace: true});
        }
    }, [
        paginationPage, paginationSize, orderBy, isDescFilter, sortOrder, selectedUser, selectedBranchId,
        filterStatusesId, filterStatusIds, filterChangeType,
        filterDateTime, filterEndDateTime, startTime, endTime,
        filterFinishDateTime, filterFinishEndDateTime, startFinishTime, endFinishTime,
        timeInStatusStartTime, timeInStatusEndTime, searchParams, setSearchParams
    ]);

    useEffect(() => {
        if (hasStartFilter && !!selectedUser) {
            if (!jwtToken?.jwtToken) {
                return;
            }
            const pageNumber = useUrlPageOnStartRef.current
                ? (initialPeriodStatusesUrlState.page || 1)
                : 1;
            if (!useUrlPageOnStartRef.current) {
                dispatch(setStatusesByPeriodCurrentPage(1));
                setFirst(0);
                setPage(1);
            }
            useUrlPageOnStartRef.current = false;
            let filter: { key: string; value: string }[] = [];
            const dataSort: StatusByPeriodDataSort = {
                pageNumber,
                pageSize: paginationSize,
                sort: {
                    orderBy: orderBy ? orderBy : "TimeStart",
                    isDesc: isDescFilter
                }
            }

            if (filterStatusesId?.value) {
                filter.push(filterStatusesId);
            }
            if (filterStatusName?.value) {
                filter.push(filterStatusName);
            }
            if (filterStatusIds) {
                filterStatusIds.map((item: any) => {
                    filter.push(item);
                })
            }
            if (filterTypeId) {
                filterTypeId.map((item: any) => {
                    filter.push(item);
                })
            }
            if (filterStatusId) {
                dataSort.active = filterStatusId?.value
            }

            if (filterChangeType?.value) {
                filter.push(filterChangeType);
            }

            if (selectedUser) {
                filter.push({
                    key: "UserName",
                    value: typeof selectedUser === 'string' ? selectedUser : selectedUser.userName
                });
            }

            if (filterDateTime && filterEndDateTime && startTime && endTime) {
                let startDate = formatDate(filterDateTime);
                let endDate = formatDate(filterEndDateTime);
                let filterStartTime = getTime(startTime);
                let filterEndTime = getTime(endTime);
                filter.push({
                    key: "TimeStart",
                    value: `${startDate} ${filterStartTime},${endDate} ${filterEndTime}`
                });
            }

            if (filterFinishDateTime && filterFinishEndDateTime && startFinishTime && endFinishTime) {
                let startDate = formatDate(filterFinishDateTime);
                let endDate = formatDate(filterFinishEndDateTime);
                let filterStartTime = getTime(startFinishTime);
                let filterEndTime = getTime(endFinishTime);
                filter.push({
                    key: "TimeEnd",
                    value: `${startDate} ${filterStartTime},${endDate} ${filterEndTime}`
                });
            }

            if (timeInStatusStartTime && timeInStatusEndTime &&
                (!isDefaultTime(timeInStatusStartTime) || !isDefaultTime(timeInStatusEndTime))) {
                const startSeconds = getTotalSeconds(timeInStatusStartTime);
                const endSeconds = getTotalSeconds(timeInStatusEndTime);
                if (startSeconds !== null && endSeconds !== null) {
                    filter.push({
                        key: 'TimeInStatus',
                        value: `${startSeconds},${endSeconds}`
                    });
                }
            }

            if (filter.length > 0) {
                dataSort['filter'] = filter;
            }

            applyBranchIdToDataSort(dataSort);

            dispatch(getStatusesByPeriodWithPaginationFilterAndSorting(dataSort, jwtToken?.jwtToken));
            dispatch(setStatusesByPeriodFilter(dataSort));
            setPage(null);
            setSortData(dataSort);
            setHasStartFilter(false);
        }
    }, [hasStartFilter, jwtToken?.jwtToken]);

    useEffect(() => {
        if (hasEndFilter && !!selectedUser) {
            dispatch(setStatusesByPeriodCurrentPage(1));
            setFirst(0);
            setPage(1);
            let filter: { key: string; value: string }[] = [];
            const dataSort: StatusByPeriodDataSort = {
                pageNumber: 1,
                pageSize: paginationSize,
                sort: {
                    orderBy: orderBy ? orderBy : "TimeStart",
                    isDesc: isDescFilter
                }
            }

            if (filterStatusesId?.value) {
                filter.push(filterStatusesId);
            }
            if (filterStatusName?.value) {
                filter.push(filterStatusName);
            }
            if (filterStatusIds) {
                filterStatusIds.map((item: any) => {
                    filter.push(item);
                })
            }
            if (filterTypeId) {
                filterTypeId.map((item: any) => {
                    filter.push(item);
                })
            }
            if (filterStatusId) {
                dataSort.active = filterStatusId?.value
            }

            if (filterChangeType?.value) {
                filter.push(filterChangeType);
            }

            if (selectedUser) {
                filter.push({
                    key: "UserName",
                    value: typeof selectedUser === 'string' ? selectedUser : selectedUser.userName
                });
            }

            if (filterDateTime && filterEndDateTime && startTime && endTime) {
                let startDate = formatDate(filterDateTime);
                let endDate = formatDate(filterEndDateTime);
                let filterStartTime = getTime(startTime);
                let filterEndTime = getTime(endTime);
                filter.push({
                    key: "TimeStart",
                    value: `${startDate} ${filterStartTime},${endDate} ${filterEndTime}`
                });
            }

            if (filterFinishDateTime && filterFinishEndDateTime && startFinishTime && endFinishTime) {
                let startDate = formatDate(filterFinishDateTime);
                let endDate = formatDate(filterFinishEndDateTime);
                let filterStartTime = getTime(startFinishTime);
                let filterEndTime = getTime(endFinishTime);
                filter.push({
                    key: "TimeEnd",
                    value: `${startDate} ${filterStartTime},${endDate} ${filterEndTime}`
                });
            }

            if (timeInStatusStartTime && timeInStatusEndTime &&
                (!isDefaultTime(timeInStatusStartTime) || !isDefaultTime(timeInStatusEndTime))) {
                const startSeconds = getTotalSeconds(timeInStatusStartTime);
                const endSeconds = getTotalSeconds(timeInStatusEndTime);
                if (startSeconds !== null && endSeconds !== null) {
                    filter.push({
                        key: 'TimeInStatus',
                        value: `${startSeconds},${endSeconds}`
                    });
                }
            }

            if (filter.length > 0) {
                dataSort['filter'] = filter;
            }

            applyBranchIdToDataSort(dataSort);

            dispatch(getStatusesByPeriodWithPaginationFilterAndSorting(dataSort, jwtToken?.jwtToken));
            dispatch(setStatusesByPeriodFilter(dataSort));
            setPage(null);
            setSortData(dataSort);
            setHasEndFilter(false);
        }
    }, [hasEndFilter, jwtToken?.jwtToken]);

    useEffect(() => {
        if (hasTimeInStatusFilter && !!selectedUser) {
            dispatch(setStatusesByPeriodCurrentPage(1));
            setFirst(0);
            setPage(1);
            let filter: { key: string; value: string }[] = [];
            const dataSort: StatusByPeriodDataSort = {
                pageNumber: 1,
                pageSize: paginationSize,
                sort: {
                    orderBy: orderBy ? orderBy : "TimeStart",
                    isDesc: isDescFilter
                }
            }

            if (filterStatusesId?.value) {
                filter.push(filterStatusesId);
            }
            if (filterStatusName?.value) {
                filter.push(filterStatusName);
            }
            if (filterStatusIds) {
                filterStatusIds.map((item: any) => {
                    filter.push(item);
                })
            }
            if (filterTypeId) {
                filterTypeId.map((item: any) => {
                    filter.push(item);
                })
            }
            if (filterStatusId) {
                dataSort.active = filterStatusId?.value
            }

            if (filterChangeType?.value) {
                filter.push(filterChangeType);
            }

            if (selectedUser) {
                filter.push({
                    key: "UserName",
                    value: typeof selectedUser === 'string' ? selectedUser : selectedUser.userName
                });
            }

            if (filterDateTime && filterEndDateTime && startTime && endTime) {
                let startDate = formatDate(filterDateTime);
                let endDate = formatDate(filterEndDateTime);
                let filterStartTime = getTime(startTime);
                let filterEndTime = getTime(endTime);
                filter.push({
                    key: "TimeStart",
                    value: `${startDate} ${filterStartTime},${endDate} ${filterEndTime}`
                });
            }

            if (filterFinishDateTime && filterFinishEndDateTime && startFinishTime && endFinishTime) {
                let startDate = formatDate(filterFinishDateTime);
                let endDate = formatDate(filterFinishEndDateTime);
                let filterStartTime = getTime(startFinishTime);
                let filterEndTime = getTime(endFinishTime);
                filter.push({
                    key: "TimeEnd",
                    value: `${startDate} ${filterStartTime},${endDate} ${filterEndTime}`
                });
            }

            if (timeInStatusStartTime && timeInStatusEndTime &&
                (!isDefaultTime(timeInStatusStartTime) || !isDefaultTime(timeInStatusEndTime))) {
                const startSeconds = getTotalSeconds(timeInStatusStartTime);
                const endSeconds = getTotalSeconds(timeInStatusEndTime);
                if (startSeconds !== null && endSeconds !== null) {
                    filter.push({
                        key: 'TimeInStatus',
                        value: `${startSeconds},${endSeconds}`
                    });
                }
            }

            if (filter.length > 0) {
                dataSort['filter'] = filter;
            }

            applyBranchIdToDataSort(dataSort);

            justAppliedTimeInStatusFilter.current = true;
            timeInStatusFilterRequestSent.current = true;

            dispatch(getStatusesByPeriodWithPaginationFilterAndSorting(dataSort, jwtToken?.jwtToken));


            setTimeout(() => {
                setHasTimeInStatusFilter(false);
                setTimeout(() => {
                    justAppliedTimeInStatusFilter.current = false;
                    timeInStatusFilterRequestSent.current = false;
                }, 200);
            }, 100);
        }
    }, [hasTimeInStatusFilter, jwtToken?.jwtToken]);

    useEffect(() => {
        if (activeClick?.item === "/period_statuses" && activeClick?.from ==='#/period_statuses' && !!selectedUser) {
            dispatch(getStatusesByPeriodWithPaginationFilterAndSorting(sortData, jwtToken?.jwtToken));
            resetTableHorizontalScroll();
        }
    }, [activeClick]);

    const filterClearTemplate = (options: any) => {
        return <Button type="button" icon="pi pi-times" onClick={options.filterClearCallback} className="p-button-secondary"></Button>;
    }

    const filterApplyTemplate = (options: {
        filterApplyCallback: React.MouseEventHandler<HTMLButtonElement> | undefined;
        field: string;
    }) => {
        const handleClick = () => {
            if (options.field === 'timeStart') {
                if (!startTime) setStartTime(getDefaultStartTime());
                if (!endTime) setEndTime(getDefaultEndTime());
            }

            if (options.field === 'timeEnd') {
                if (!startFinishTime) setStartFinishTime(getDefaultStartTime());
                if (!endFinishTime) setEndFinishTime(getDefaultEndTime());

                if (!filterFinishDateTime) setFilterFinishDateTime(getDefaultStartDate());
                if (!filterFinishEndDateTime) setFilterFinishEndDateTime(getDefaultEndDate());

                setHasEndFilter(true);

                if (dataTableRef.current) {
                    const filterValue = endFinishTime || getDefaultEndTime();
                    dataTableRef.current.filter(filterValue, 'timeEnd', 'contains');
                }
            }

            if (options.field === 'timeInStatus') {
                if (!timeInStatusStartTime) setTimeInStatusStartTime(getDefaultStartTime());
                if (!timeInStatusEndTime) setTimeInStatusEndTime(getDefaultStartTime());

                justAppliedTimeInStatusFilter.current = true;
                setHasTimeInStatusFilter(true);

                if (dataTableRef.current) {
                    const filterValue = timeInStatusStartTime || getDefaultStartTime();
                    dataTableRef.current.filter(filterValue, 'timeInStatus', 'contains');
                }
                return;
            }

            if (options.filterApplyCallback) {
                options.filterApplyCallback({} as any);
            }
        };

        return <Button type="button" icon="pi pi-check" onClick={handleClick} className=""></Button>
    }

    const dataTableRef = useRef<any>(null);

    const handleReset = () => {
        dataTableRef?.current?.reset();
        customFilter();
        setSortOrder(0);
        setTimeInStatusStartTime(getDefaultStartTime());
        setTimeInStatusEndTime(getDefaultStartTime());
        setHasTimeInStatusFilter(false);
        setFilterFinishDateTime(false);
        setFilterFinishEndDateTime(false);
        setStartFinishTime(null);
        setEndFinishTime(null);
        setStartTime(new Date("2024-10-29 00:00:00"));
        setEndTime(() => {
            const d = new Date();
            d.setHours(23, 59, 59, 0);
            return d;
        });
        setFilterDateTime(new Date());
        setFilterEndDateTime(new Date());
        setSelectedBranchId(null);
        dispatch(setStatusesByPeriodClearFilters());
        dispatch(setStatusesByPeriodCurrentPageSize(10));
        dispatch(setStatusesByPeriodCurrentPage(1));
        setFirst(0);
        setSelectedUser(null);
        skipUrlWriteRef.current = true;
        const resetParams = new URLSearchParams();
        if (persistChildWindow) {
            resetParams.set('childWindow', '1');
        }
        setSearchParams(resetParams, {replace: true});
        setTableMountKey((key) => key + 1);
    };

    useEffect(() => {
        if (initialPeriodStatusesUrlState.hasAny) {
            return;
        }
        handleReset();
    }, []);

    const onPageChange = (event: any) => {
        setFirst(event.first);
        dispatch(setStatusesByPeriodCurrentPage(event.page + 1));
        dispatch(setStatusesByPeriodCurrentPageSize(event.rows));
        setSortData((prev: any) => ({...prev, pageNumber: event.page + 1, pageSize: event.rows}));
    };

    const customSort = (event: any) => {
        const handleAction = (sortField: string) => {
            let newOrderBy: string;

            switch (sortField) {
                case 'statusName':
                    newOrderBy = 'StatusName';
                    break;
                case 'timeStart':
                    newOrderBy = 'TimeStart';
                    break;
                case 'TimeEnd':
                    newOrderBy = 'TimeEnd';
                    break;
                case 'TimeInStatus':
                    newOrderBy = 'TimeInStatus';
                    break;
                default:
                    return;
            }

            setOrderBy(newOrderBy);
            setIsDescFilter(!isDescFilter);
            setSortOrder(sortOrder === 1 ? -1 : 1);
        };
        let sortField = event.sortField;
        handleAction(sortField);
    };


    const customFilter = (event?: any) => {
        if (event) {
            const {id, statusName, active, typeId, changeType} = event.filters;
            setFilterStatusesId(id?.constraints?.[0]?.value ? {key: 'Id', value: id.constraints[0].value} : null);
            setFilterStatusId(active?.value ? {key: 'Active', value: active.value.code ?? active.value} : null);
            if (typeId?.value) {
                setFilterTypeId(typeId.value.map((item: any) => ({key: 'TypeId', value: String(item)})));
            } else {
                setFilterTypeId(null);
            }
            if (statusName?.value) {
                setFilterStatusIds(statusName.value.map((item: any) => ({key: 'StatusId', value: String(item)})));
            } else {
                setFilterStatusIds(null);
            }
            setFilterChangeType(changeType?.value ? {key: 'ChangeType', value: changeType.value} : null);
        } else {
            setFilterStatusesId(null);
            setFilterTypeId(null);
            setFilterStatusName(null);
            setFilterStatusId(null);
            setFilterStatusIds(null);
            setFilterChangeType(null);
            setOrderBy(null);
            setIsDescFilter(true);
        }
    };

    const renderHeader = (field: string, sortField: string) => {
        const sorted = sortField === orderBy;
        const sortIcon = classNames('p-sortable-column-icon', {
            'pi pi-sort-amount-up-alt': sorted && sortOrder === 1,
            'pi pi-fw pi-sort-amount-down': sorted && sortOrder === -1,
            'pi pi-fw pi-sort-alt': sortOrder === 0 || !sorted
        });

        return (
            <div className="flex align-items-center sticky top-0" onClick={() => customSort({'sortField': sortField})}>
                {field} <i className={sortIcon}></i>
            </div>
        );
    };

    const isMobile = () => {
        return windowWidth <= 1248;
    }

    const statusFilterTemplate = (options: any) => {
        return (
            <>
                <div className="mb-3 text-bold">Оберіть статус</div>
                <MultiSelect
                    filter
                    value={options.value}
                    options={statusesList}
                    optionValue="id"
                    onChange={(e) => options.filterCallback(e.value, options.index)}
                    placeholder="нічого не обрано"
                    className="p-column-filter"
                    optionLabel="statusName"
                />
            </>
        );
    };

    const workStateFilterTemplate = (options: any) => {
        return (
            <>
                <div className="mb-3 text-bold">Оберіть:</div>
                <MultiSelect
                    filter
                    value={options.value}
                    options={statusesDictionary && statusesDictionary.map((item: { dictionaryId: any; }) => item.dictionaryId)}
                    itemTemplate={workStateItemTemplate}
                    selectedItemTemplate={selectedWorkStateTemplate}
                    onChange={(e) => options.filterCallback(e.value, options.index)}
                    placeholder="нічого не обрано"
                    className="p-column-filter"
                />
            </>
        );
    };

    const selectedWorkStateTemplate = (option: any) => {
        let typeName = statusesDictionary.map((item: { dictionaryId: any; description: any; }) => {
            if (item.dictionaryId === option) {
                return item.description
            }
        })
        if (option) {
            return (
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {typeName},
                </span>
            );
        }

        return "Оберіть роль";
    }

    const workStateItemTemplate = (option: any) => {
        let typeName = statusesDictionary.map((item: { dictionaryId: any; description: any; }) => {
            if (item.dictionaryId === option) {
                return item.description
            }
        })
        return (
            <div className="p-multiselect-representative-option">
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {typeName}
                </span>
            </div>
        );
    }

    const changeTypeOptions = [
        {name: 'Автоматичний', value: 'Автоматичний'},
        {name: 'Ручний', value: 'Ручний'}
    ];

    const changeTypeFilterTemplate = (options: any) => {
        return (
            <>
                <div className="mb-3 text-bold">Оберіть:</div>
                <Dropdown
                    filter
                    value={options.value}
                    options={changeTypeOptions}
                    onChange={(e) => options.filterCallback(e.value, options.index)}
                    placeholder="нічого не обрано"
                    optionLabel="name"
                    optionValue="value"
                    className="p-column-filter"
                />
            </>
        );
    };

    const getActiveFilterClassName = (baseClassName: string, isActive: boolean) => {
        const result = isActive ? `${baseClassName} active-time-filter` : baseClassName;
        return result;
    };

    const isTimeFilterActive = (filterName: string) => {
        let result = false;
        switch (filterName) {
            case 'duration':
                result = duration;
                break;
            case 'timeInStatus':
                result = hasTimeInStatusFilter;
                break;
            default:
                result = false;
        }

        return result;
    };

    const getTotalSeconds = (date: any) => {
        if (!date) return null;
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const seconds = date.getSeconds();
        return hours * 3600 + minutes * 60 + seconds;
    };

    const isDefaultTime = (time: Date | null | false): boolean => {
        if (!time) return true;
        const defaultTime = getDefaultStartTime();
        return time.getTime() === defaultTime.getTime();
    };

    const durationFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <>
            <span className="title">Виберіть час:</span>
            <div className="flex field align-items-center max-w-15rem">
                <span className="title" style={{width: '35px'}}>З*</span>
                <Calendar
                    appendTo="self"
                    id="icon"
                    placeholder="00:00:00"
                    timeOnly
                    showSeconds
                    hourFormat="24"
                    className={getActiveFilterClassName("mt-2", isTimeFilterActive('duration'))}
                    value={durationStartTime || null}
                    onChange={(e: any) => {
                        if (e.value) setdurationStartTime(e.value);
                    }}
                    onFocus={() => {
                        setdurationStartTime(null);
                    }}
                    onBlur={() => {
                        if (!durationStartTime) {
                            const defaultTime = getDefaultStartTime();
                            if (defaultTime) {
                                setdurationStartTime(defaultTime);
                            }
                        }
                    }}
                    onInput={(e: any) => {
                        const input = e.target as HTMLInputElement;

                        const digits = input.value.replace(/\D/g, "").slice(0, 6);
                        const HH = digits.slice(0, 2);
                        const MM = digits.slice(2, 4);
                        const SS = digits.slice(4, 6);

                        const display =
                            HH +
                            (digits.length > 2 ? ":" + MM : "") +
                            (digits.length > 4 ? ":" + SS : "");

                        if (input.value !== display) {
                            const caret =
                                digits.length +
                                (digits.length > 2 ? 1 : 0) +
                                (digits.length > 4 ? 1 : 0);
                            input.value = display;
                            input.setSelectionRange(caret, caret);
                        }

                        if (digits.length === 6) {
                            const h = parseInt(HH, 10);
                            const m = parseInt(MM, 10);
                            const s = parseInt(SS, 10);
                            const valid =
                                h >= 0 && h <= 23 &&
                                m >= 0 && m <= 59 &&
                                s >= 0 && s <= 59;

                            if (valid) {
                                const base =
                                    durationStartTime
                                        ? new Date(durationStartTime)
                                        : (getDefaultStartTime() ? new Date(getDefaultStartTime()) : new Date());
                                base.setHours(h, m, s, 0);
                                setdurationStartTime(base);
                            }
                        }
                    }}
                    // showOnFocus={false}
                    // hideOnDateTimeSelect={false}
                />
            </div>
            <div className="flex field align-items-center max-w-15rem">
                <span className="title" style={{width: '35px'}}>По*</span>
                <Calendar
                    appendTo="self"
                    id="icon"
                    timeOnly
                    showSeconds
                    className={getActiveFilterClassName("mt-2", isTimeFilterActive('duration'))}
                    value={durationEndTime || null}
                    onChange={(e: any) => {
                        if (e.value) setdurationEndTime(e.value);
                    }}
                    onFocus={() => {
                        setdurationEndTime(null);
                    }}
                    onBlur={() => {
                        if (!durationEndTime) {
                            const defaultTime = getDefaultStartTime();
                            if (defaultTime) {
                                setdurationEndTime(defaultTime);
                            }
                        }
                    }}
                    onInput={(e: any) => {
                        const input = e.target as HTMLInputElement;

                        const digits = input.value.replace(/\D/g, "").slice(0, 6);
                        const HH = digits.slice(0, 2);
                        const MM = digits.slice(2, 4);
                        const SS = digits.slice(4, 6);

                        const display =
                            HH +
                            (digits.length > 2 ? ":" + MM : "") +
                            (digits.length > 4 ? ":" + SS : "");

                        if (input.value !== display) {
                            const caret =
                                digits.length +
                                (digits.length > 2 ? 1 : 0) +
                                (digits.length > 4 ? 1 : 0);
                            input.value = display;
                            input.setSelectionRange(caret, caret);
                        }

                        if (digits.length === 6) {
                            const h = parseInt(HH, 10);
                            const m = parseInt(MM, 10);
                            const s = parseInt(SS, 10);
                            const valid =
                                h >= 0 && h <= 23 &&
                                m >= 0 && m <= 59 &&
                                s >= 0 && s <= 59;

                            if (valid) {
                                const base =
                                    durationEndTime
                                        ? new Date(durationEndTime)
                                        : (getDefaultStartTime() ? new Date(getDefaultStartTime()) : new Date());
                                base.setHours(h, m, s, 0);
                                setdurationEndTime(base);
                            }
                        }
                    }}
                    placeholder="00:00:00"
                    hourFormat="24"
                    // showOnFocus={false}
                    // hideOnDateTimeSelect={false}
                />
            </div>
        </>
    };

    const timeInStatusFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <>
            <span className="title">Виберіть час:</span>
            <div className="flex field align-items-center max-w-15rem">
                <span className="title" style={{width: '35px'}}>З*</span>
                <Calendar
                    appendTo="self"
                    id="icon"
                    placeholder="00:00:00"
                    timeOnly
                    showSeconds
                    hourFormat="24"
                    className={getActiveFilterClassName("mt-2", isTimeFilterActive('timeInStatus'))}
                    value={timeInStatusStartTime || null}
                    onChange={(e: any) => {
                        if (e.value) setTimeInStatusStartTime(e.value);
                    }}
                    onFocus={() => {
                        setTimeInStatusStartTime(null);
                    }}
                    onBlur={() => {
                        if (!timeInStatusStartTime) {
                            const defaultTime = getDefaultStartTime();
                            if (defaultTime) {
                                setTimeInStatusStartTime(defaultTime);
                            }
                        }
                    }}
                    onInput={(e: any) => {
                        const input = e.target as HTMLInputElement;

                        const digits = input.value.replace(/\D/g, "").slice(0, 6);
                        const HH = digits.slice(0, 2);
                        const MM = digits.slice(2, 4);
                        const SS = digits.slice(4, 6);

                        const display =
                            HH +
                            (digits.length > 2 ? ":" + MM : "") +
                            (digits.length > 4 ? ":" + SS : "");

                        if (input.value !== display) {
                            const caret =
                                digits.length +
                                (digits.length > 2 ? 1 : 0) +
                                (digits.length > 4 ? 1 : 0);
                            input.value = display;
                            input.setSelectionRange(caret, caret);
                        }

                        if (digits.length === 6) {
                            const h = parseInt(HH, 10);
                            const m = parseInt(MM, 10);
                            const s = parseInt(SS, 10);
                            const valid =
                                h >= 0 && h <= 23 &&
                                m >= 0 && m <= 59 &&
                                s >= 0 && s <= 59;

                            if (valid) {
                                const base =
                                    timeInStatusStartTime
                                        ? new Date(timeInStatusStartTime)
                                        : (getDefaultStartTime() ? new Date(getDefaultStartTime()) : new Date());
                                base.setHours(h, m, s, 0);
                                setTimeInStatusStartTime(base);
                            }
                        }
                    }}
                />
            </div>
            <div className="flex field align-items-center max-w-15rem">
                <span className="title" style={{width: '35px'}}>По*</span>
                <Calendar
                    appendTo="self"
                    id="icon"
                    timeOnly
                    showSeconds
                    className={getActiveFilterClassName("mt-2", isTimeFilterActive('timeInStatus'))}
                    value={timeInStatusEndTime || null}
                    onChange={(e: any) => {
                        if (e.value) setTimeInStatusEndTime(e.value);
                    }}
                    onFocus={() => {
                        setTimeInStatusEndTime(null);
                    }}
                    onBlur={() => {
                        if (!timeInStatusEndTime) {
                            const defaultTime = getDefaultStartTime();
                            if (defaultTime) {
                                setTimeInStatusEndTime(defaultTime);
                            }
                        }
                    }}
                    onInput={(e: any) => {
                        const input = e.target as HTMLInputElement;

                        const digits = input.value.replace(/\D/g, "").slice(0, 6);
                        const HH = digits.slice(0, 2);
                        const MM = digits.slice(2, 4);
                        const SS = digits.slice(4, 6);

                        const display =
                            HH +
                            (digits.length > 2 ? ":" + MM : "") +
                            (digits.length > 4 ? ":" + SS : "");

                        if (input.value !== display) {
                            const caret =
                                digits.length +
                                (digits.length > 2 ? 1 : 0) +
                                (digits.length > 4 ? 1 : 0);
                            input.value = display;
                            input.setSelectionRange(caret, caret);
                        }

                        if (digits.length === 6) {
                            const h = parseInt(HH, 10);
                            const m = parseInt(MM, 10);
                            const s = parseInt(SS, 10);
                            const valid =
                                h >= 0 && h <= 23 &&
                                m >= 0 && m <= 59 &&
                                s >= 0 && s <= 59;

                            if (valid) {
                                const base =
                                    timeInStatusEndTime
                                        ? new Date(timeInStatusEndTime)
                                        : (getDefaultStartTime() ? new Date(getDefaultStartTime()) : new Date());
                                base.setHours(h, m, s, 0);
                                setTimeInStatusEndTime(base);
                            }
                        }
                    }}
                    placeholder="00:00:00"
                    hourFormat="24"
                />
            </div>
        </>
    };

    const renderStatusColumn = (rowData: any) => {
        const replaceStatusName = rowData?.statusName?.replace(/Copy.*/, 'Copy...');
        return (
            <Badge value={replaceStatusName} className={`p-badge text-white customer-badge text-xs p-0 mr-4 my-2 px-2`} style={{borderRadius: '6px', backgroundColor: `${rowData.statusColor}`, minWidth: '180px'}}/>
        );
    };

    const convertSecondsToTime = (totalSeconds: number): string => {
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = Math.floor(totalSeconds % 60);

        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    const dateFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <>
            <span className="title">Виберіть дату</span>
            <div className="flex field align-items-center max-w-15rem">
                <span className="title" style={{width: '35px'}}>З*</span>
                <Calendar className="mt-2" value={isStartDateFocused ? null : (filterDateTime || getDefaultStartDate())} onChange={(e: any) => {
                    options.filterCallback(e.value, options.index);
                    setFilterDateTime(e.value)
                }} onInput={(e: any) => {
                    const input = e.target as HTMLInputElement;

                    const digits = input.value.replace(/\D/g, "").slice(0, 8); // ddMMyyyy

                    const dd = digits.slice(0, 2);
                    const mm = digits.slice(2, 4);
                    const yyyy = digits.slice(4, 8);

                    const display =
                        (dd || "") +
                        (digits.length > 2 ? "/" + mm : "") +
                        (digits.length > 4 ? "/" + yyyy : "");

                    const newCaret =
                        digits.length +
                        (digits.length > 2 ? 1 : 0) +
                        (digits.length > 4 ? 1 : 0);

                    if (input.value !== display) {
                        input.value = display;
                        input.setSelectionRange(newCaret, newCaret);
                    }

                    if (digits.length === 8) {
                        const day = parseInt(dd, 10);
                        const month = parseInt(mm, 10) - 1; // 0-based
                        const year = parseInt(yyyy, 10);
                        const parsed = new Date(year, month, day);

                        const valid =
                            !isNaN(parsed.getTime()) &&
                            parsed.getDate() === day &&
                            parsed.getMonth() === month &&
                            parsed.getFullYear() === year;

                        setFilterDateTime(valid ? parsed : null);
                    }
                }} onFocus={(e: any) => {
                    setIsStartDateFocused(true);
                }} onBlur={(e: any) => {
                    setIsStartDateFocused(false);
                    const digits = e.target.value.replace(/\D/g, "");
                    if (digits.length !== 8) {
                        e.target.value = "";
                        setFilterDateTime(getDefaultStartDate());
                    } else if (!filterDateTime) {
                        setFilterDateTime(getDefaultStartDate());
                    }
                }} minDate={new Date(2023, 5, 1)} // 01.06.2023
                          maxDate={new Date()}
                          dateFormat="dd/mm/yy" placeholder="дд/мм/рр"/>
            </div>
            <div className="flex field align-items-center max-w-15rem">
                <span className="title" style={{width: '35px'}}>По*</span>
                <Calendar className="mt-2" value={isEndDateFocused ? null : (filterEndDateTime || getDefaultEndDate())} onChange={(e: any) => {
                    setFilterEndDateTime(e.value)
                }} onInput={(e: any) => {
                    const input = e.target as HTMLInputElement;

                    const digits = input.value.replace(/\D/g, "").slice(0, 8); // ddMMyyyy

                    const dd = digits.slice(0, 2);
                    const mm = digits.slice(2, 4);
                    const yyyy = digits.slice(4, 8);

                    const display =
                        (dd || "") +
                        (digits.length > 2 ? "/" + mm : "") +
                        (digits.length > 4 ? "/" + yyyy : "");

                    const newCaret =
                        digits.length +
                        (digits.length > 2 ? 1 : 0) +
                        (digits.length > 4 ? 1 : 0);

                    if (input.value !== display) {
                        input.value = display;
                        input.setSelectionRange(newCaret, newCaret);
                    }

                    if (digits.length === 8) {
                        const day = parseInt(dd, 10);
                        const month = parseInt(mm, 10) - 1; // 0-based
                        const year = parseInt(yyyy, 10);
                        const parsed = new Date(year, month, day);

                        const valid =
                            !isNaN(parsed.getTime()) &&
                            parsed.getDate() === day &&
                            parsed.getMonth() === month &&
                            parsed.getFullYear() === year;

                        setFilterEndDateTime(valid ? parsed : null);
                    }
                }} onFocus={(e: any) => {
                    setIsEndDateFocused(true);
                }} onBlur={(e: any) => {
                    setIsEndDateFocused(false);
                    const digits = e.target.value.replace(/\D/g, "");
                    if (digits.length !== 8) {
                        e.target.value = "";
                        setFilterEndDateTime(getDefaultEndDate());
                    } else if (!filterEndDateTime) {
                        setFilterEndDateTime(getDefaultEndDate());
                    }
                }} minDate={new Date(2023, 5, 1)} // 01.06.2023
                          maxDate={new Date()}
                          dateFormat="dd/mm/yy" placeholder="дд/мм/рр"/>
            </div>
            <div className="flex max-w-15rem">
                <div className="md:col-6">
                    <div className="time-item">
                        <span className="title">З*</span>
                        <Calendar
                            appendTo="self"
                            id="icon"
                            placeholder="00:00"
                            value={isStartFinishTimeFocused ? null : (startTime || getDefaultStartTime())}
                            timeOnly
                            hourFormat="24"
                            onChange={(e) => setStartTime(e.value)}
                            onFocus={() => {
                                setIsStartFinishTimeFocused(true);
                                if (startTime) {
                                    setStartTime(null);
                                }
                            }}
                            onInput={(e: any) => {
                                const input = e.target as HTMLInputElement;

                                let digits = input.value.replace(/\D/g, "").slice(0, 4);
                                const HH = digits.slice(0, 2);
                                const MM = digits.slice(2, 4);

                                const display = HH + (digits.length > 2 ? ":" + MM : "");

                                if (input.value !== display) {
                                    const caret = digits.length + (digits.length > 2 ? 1 : 0);
                                    input.value = display;
                                    input.setSelectionRange(caret, caret);
                                }

                                if (digits.length === 4) {
                                    const h = parseInt(HH, 10);
                                    const m = parseInt(MM, 10);
                                    const valid = h >= 0 && h <= 23 && m >= 0 && m <= 59;
                                    if (valid) {
                                        const base = startTime ? new Date(startTime) : new Date();
                                        base.setHours(h, m, 0, 0);
                                        setStartTime(base);
                                    }
                                }
                            }}
                            onBlur={() => {
                                setIsStartFinishTimeFocused(false);
                            }}
                        />
                    </div>
                </div>
                <div className="md:col-6">
                    <div className="time-item">
                        <span className="title">По*</span>
                        <Calendar
                            appendTo="self"
                            id="icon"
                            placeholder="00:00"
                            value={isEndFinishTimeFocused ? null : (endTime || getDefaultEndTime())}
                            timeOnly
                            hourFormat="24"
                            onChange={(e) => setEndTime(e.value)}
                            onFocus={() => {
                                setIsEndFinishTimeFocused(true);
                                if (endTime) {
                                    setEndTime(null);
                                }
                            }}
                            onInput={(e: any) => {
                                const input = e.target as HTMLInputElement;

                                let digits = input.value.replace(/\D/g, "").slice(0, 4);
                                const HH = digits.slice(0, 2);
                                const MM = digits.slice(2, 4);

                                const display = HH + (digits.length > 2 ? ":" + MM : "");

                                if (input.value !== display) {
                                    const caret = digits.length + (digits.length > 2 ? 1 : 0);
                                    input.value = display;
                                    input.setSelectionRange(caret, caret);
                                }

                                if (digits.length === 4) {
                                    const h = parseInt(HH, 10);
                                    const m = parseInt(MM, 10);
                                    const valid = h >= 0 && h <= 23 && m >= 0 && m <= 59;
                                    if (valid) {
                                        const base = endTime ? new Date(endTime) : new Date();
                                        base.setHours(h, m, 0, 0);
                                        setEndTime(base);
                                    }
                                }
                            }}
                            onBlur={() => {
                                setIsEndFinishTimeFocused(false);
                            }}
                        />
                    </div>
                </div>
            </div>
        </>
    };

    const dateEndFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <>
            <span className="title">Виберіть дату</span>
            <div className="flex field align-items-center max-w-15rem">
                <span className="title" style={{width: '35px'}}>З*</span>
                <Calendar className="mt-2" value={isFinishDateFocused ? null : (filterFinishDateTime || getDefaultStartDate())}
                          onChange={(e: any) => {
                              // options.filterCallback(e.value, options.index);
                              setFilterFinishDateTime(e.value)
                          }} onInput={(e: any) => {
                    const input = e.target as HTMLInputElement;

                    const digits = input.value.replace(/\D/g, "").slice(0, 8); // ddMMyyyy

                    const dd = digits.slice(0, 2);
                    const mm = digits.slice(2, 4);
                    const yyyy = digits.slice(4, 8);

                    const display =
                        (dd || "") +
                        (digits.length > 2 ? "/" + mm : "") +
                        (digits.length > 4 ? "/" + yyyy : "");

                    const newCaret =
                        digits.length +
                        (digits.length > 2 ? 1 : 0) +
                        (digits.length > 4 ? 1 : 0);

                    if (input.value !== display) {
                        input.value = display;
                        input.setSelectionRange(newCaret, newCaret);
                    }

                    if (digits.length === 8) {
                        const day = parseInt(dd, 10);
                        const month = parseInt(mm, 10) - 1; // 0-based
                        const year = parseInt(yyyy, 10);
                        const parsed = new Date(year, month, day);

                        const valid =
                            !isNaN(parsed.getTime()) &&
                            parsed.getDate() === day &&
                            parsed.getMonth() === month &&
                            parsed.getFullYear() === year;

                        setFilterFinishDateTime(valid ? parsed : null);
                    }
                }} onFocus={(e: any) => {
                    setIsFinishDateFocused(true);
                }} onBlur={(e: any) => {
                    setIsFinishDateFocused(false);
                    const digits = e.target.value.replace(/\D/g, "");
                    if (digits.length !== 8) {
                        e.target.value = "";
                        setFilterFinishDateTime(getDefaultStartDate());
                    } else if (!filterFinishDateTime) {
                        setFilterFinishDateTime(getDefaultStartDate());
                    }
                }} minDate={new Date(2023, 5, 1)} // 01.06.2023
                          maxDate={new Date()}
                          dateFormat="dd/mm/yy" placeholder="дд/мм/рр"/>
            </div>
            <div className="flex field align-items-center max-w-15rem">
                <span className="title" style={{width: '35px'}}>По*</span>
                <Calendar className="mt-2" value={isFinishEndDateFocused ? null : (filterFinishEndDateTime || getDefaultEndDate())}
                          onChange={(e: any) => {
                              setFilterFinishEndDateTime(e.value)
                          }} onInput={(e: any) => {
                    const input = e.target as HTMLInputElement;

                    const digits = input.value.replace(/\D/g, "").slice(0, 8); // ddMMyyyy

                    const dd = digits.slice(0, 2);
                    const mm = digits.slice(2, 4);
                    const yyyy = digits.slice(4, 8);

                    const display =
                        (dd || "") +
                        (digits.length > 2 ? "/" + mm : "") +
                        (digits.length > 4 ? "/" + yyyy : "");

                    const newCaret =
                        digits.length +
                        (digits.length > 2 ? 1 : 0) +
                        (digits.length > 4 ? 1 : 0);

                    if (input.value !== display) {
                        input.value = display;
                        input.setSelectionRange(newCaret, newCaret);
                    }

                    if (digits.length === 8) {
                        const day = parseInt(dd, 10);
                        const month = parseInt(mm, 10) - 1; // 0-based
                        const year = parseInt(yyyy, 10);
                        const parsed = new Date(year, month, day);

                        const valid =
                            !isNaN(parsed.getTime()) &&
                            parsed.getDate() === day &&
                            parsed.getMonth() === month &&
                            parsed.getFullYear() === year;

                        setFilterFinishEndDateTime(valid ? parsed : null);
                    }
                }} onFocus={(e: any) => {
                    setIsFinishEndDateFocused(true);
                }} onBlur={(e: any) => {
                    setIsFinishEndDateFocused(false);
                    const digits = e.target.value.replace(/\D/g, "");
                    if (digits.length !== 8) {
                        e.target.value = "";
                        setFilterFinishEndDateTime(getDefaultEndDate());
                    } else if (!filterFinishEndDateTime) {
                        setFilterFinishEndDateTime(getDefaultEndDate());
                    }
                }} minDate={new Date(2023, 5, 1)} // 01.06.2023
                          maxDate={new Date()}
                          dateFormat="dd/mm/yy" placeholder="дд/мм/рр"/>
            </div>
            <div className="flex max-w-15rem">
                <div className="md:col-6">
                    <div className="time-item">
                        <span className="title">З*</span>
                        <Calendar
                            appendTo="self"
                            id="icon"
                            placeholder="00:00"
                            value={isStartFinishTimeFocused ? null : (startFinishTime || getDefaultStartTime())}
                            timeOnly
                            hourFormat="24"
                            onChange={(e) => setStartFinishTime(e.value)}
                            onFocus={() => {
                                setIsStartFinishTimeFocused(true);
                            }}
                            onBlur={() => {
                                setIsStartFinishTimeFocused(false);
                                if (!startFinishTime) {
                                    const defaultTime = getDefaultStartTime();
                                    if (defaultTime) {
                                        setStartFinishTime(defaultTime);
                                    }
                                }
                            }}
                            onInput={(e: any) => {
                                const input = e.target as HTMLInputElement;

                                let digits = input.value.replace(/\D/g, "").slice(0, 4);
                                const HH = digits.slice(0, 2);
                                const MM = digits.slice(2, 4);

                                const display = HH + (digits.length > 2 ? ":" + MM : "");

                                if (input.value !== display) {
                                    const caret = digits.length + (digits.length > 2 ? 1 : 0);
                                    input.value = display;
                                    input.setSelectionRange(caret, caret);
                                }

                                if (digits.length === 4) {
                                    const h = parseInt(HH, 10);
                                    const m = parseInt(MM, 10);
                                    const valid = h >= 0 && h <= 23 && m >= 0 && m <= 59;
                                    if (valid) {
                                        const base = startFinishTime ? new Date(startFinishTime) : new Date();
                                        base.setHours(h, m, 0, 0);
                                        setStartFinishTime(base);
                                    }
                                }
                            }}
                        />
                    </div>
                </div>
                <div className="md:col-6">
                    <div className="time-item">
                        <span className="title">По*</span>
                        <Calendar
                            appendTo="self"
                            id="icon"
                            placeholder="00:00"
                            value={isEndFinishTimeFocused ? null : (endFinishTime || getDefaultEndTime())}
                            timeOnly
                            hourFormat="24"
                            onChange={(e) => setEndFinishTime(e.value)}
                            onFocus={() => {
                                setIsEndFinishTimeFocused(true);
                            }}
                            onBlur={() => {
                                setIsEndFinishTimeFocused(false);
                                if (!endFinishTime) {
                                    const defaultTime = getDefaultEndTime();
                                    if (defaultTime) {
                                        setEndFinishTime(defaultTime);
                                    }
                                }
                            }}
                            onInput={(e: any) => {
                                const input = e.target as HTMLInputElement;

                                let digits = input.value.replace(/\D/g, "").slice(0, 4);
                                const HH = digits.slice(0, 2);
                                const MM = digits.slice(2, 4);

                                const display = HH + (digits.length > 2 ? ":" + MM : "");

                                if (input.value !== display) {
                                    const caret = digits.length + (digits.length > 2 ? 1 : 0);
                                    input.value = display;
                                    input.setSelectionRange(caret, caret);
                                }

                                if (digits.length === 4) {
                                    const h = parseInt(HH, 10);
                                    const m = parseInt(MM, 10);
                                    const valid = h >= 0 && h <= 23 && m >= 0 && m <= 59;
                                    if (valid) {
                                        const base = endFinishTime ? new Date(endFinishTime) : new Date();
                                        base.setHours(h, m, 0, 0);
                                        setEndFinishTime(base);
                                    }
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        </>
    };


    return (
        <div className="layout-dashboard">
            <Toast ref={toast}/>
            <div className="">
                <div className="flex col-12 md:col-12 flex-wrap p-0">
                    <div className={classNames('card widget-table col-12 transition-duration-300 monitoring-table align-self-start m-0 mr-0', {'': selectedRowData && !isMobile(), 'md:col-12': !selectedRowData})}>
                        <StatusesByPeriodListNav
                            handleReset={handleReset}
                            sortData={sortData}
                            activity={activity}
                            setActivity={setActivity}
                            activityChangedManuallyRefStatus={activityChangedManuallyRefStatus}
                            filterDateTime={filterDateTime}
                            setFilterDateTime={setFilterDateTime}
                            filterEndDateTime={filterEndDateTime}
                            setFilterEndDateTime={setFilterEndDateTime}
                            startTime={startTime}
                            setStartTime={setStartTime}
                            endTime={endTime}
                            setEndTime={setEndTime}
                            allTimeChecked={allTimeChecked}
                            setAllTimeChecked={setAllTimeChecked}
                            hasStartFilter={hasStartFilter}
                            setHasStartFilter={setHasStartFilter}
                            resetSorting={handleReset}
                            profileMenuPin={false}
                            selectedUser={selectedUser}
                            setSelectedUser={setSelectedUser}
                        />
                        <DataTable
                            key={tableMountKey}
                            ref={dataTableRef}
                            scrollable
                            scrollHeight={(selectedRowData) && !isMobile() ? '33vh' : '70vh'}
                            className="p-datatable-customers"
                            value={statusesByPeriodList}
                            dataKey="id"
                            filters={clearFilters}
                            lazy
                            rowHover={false}
                            selectionMode="single"
                            selection={selectedRowData}
                            onSort={customSort}
                            onFilter={customFilter}
                            emptyMessage="Нічого не знайдено"
                            responsiveLayout='scroll'
                            onRowClick={(e) => {
                                setSelectedRowData(e.data);
                                if (isMobile()) {
                                    setVisible(true);
                                }
                            }}
                            loading={loader}
                            rowClassName={(rowData: any) =>
                                rowData?.id === selectedRowData?.id ? 'p-highlight' : ''
                            }
                        >
                            <Column
                                field="statusName"
                                filterField="statusName"
                                body={renderStatusColumn}
                                header={renderHeader('Статус', 'StatusName')}
                                sortable
                                filter
                                showFilterMatchModes={false}
                                showFilterMenuOptions={false}
                                filterClear={filterClearTemplate}
                                filterApply={filterApplyTemplate}
                                filterElement={statusFilterTemplate}
                                style={{cursor: 'pointer', minWidth: '230px', width: `100%`}}
                            />
                            <Column
                                header={renderHeader('Тривалість', 'TimeInStatus')}
                                className="justify-content-start"
                                body={(data) => data.timeInStatus && data?.timeInStatus !== -1 ? convertSecondsToTime(data.timeInStatus) : data?.timeInStatus === 0 ? '00:00:00' : '- - -'}
                                style={{cursor: 'pointer', width: `100%`, minWidth: '165px'}}
                                sortable
                                filterPlaceholder="Введіть час"
                                filter
                                showFilterMatchModes={false}
                                showFilterMenuOptions={false}
                                filterClear={filterClearTemplate}
                                filterApply={filterApplyTemplate}
                                filterField="timeInStatus"
                                filterElement={timeInStatusFilterTemplate}
                            />
                            <Column
                                field="changeType"
                                filterField="changeType"
                                header={renderHeader('Ініціатор зміни:', 'ChangeType')}
                                // header={'Ініціатор зміни'}
                                className={classNames('', {'active-header-column': orderBy === 'ChangeType'})}
                                showFilterMatchModes={false}
                                showFilterMenuOptions={false}
                                filter
                                body={data => data?.changeType  || ''}
                                // sortable
                                filterClear={filterClearTemplate}
                                filterApply={filterApplyTemplate}
                                filterElement={changeTypeFilterTemplate}
                                style={{cursor: 'pointer', width: '100%', minWidth: '150px'}}
                            />
                            <Column
                                field="timeStart"
                                filterField="timeStart"
                                filterElement={dateFilterTemplate}
                                showFilterMatchModes={false}
                                showFilterMenuOptions={false}
                                filterPlaceholder="Введіть ID кампанії"
                                // filter
                                body={(data) => data?.timeStart ? formatDateTime(data?.timeStart) : '- - -'}
                                filterClear={filterClearTemplate}
                                filterApply={filterApplyTemplate}
                                filterMenuClassName={'filterStart'}
                                header={renderHeader('Початок', 'TimeStart')}
                                sortable
                                style={{cursor: 'pointer', width: `100%`, minWidth: '170px'}}
                            />
                            <Column
                                header={renderHeader('Завершення', 'TimeEnd')}
                                className="justify-content-start"
                                body={(data) => data?.timeEnd ? formatDateTime(data?.timeEnd) : '- - -'}
                                style={{cursor: 'pointer', width: `100%`, minWidth: '170px'}}
                                sortable
                                filterPlaceholder="Введіть час"
                                filter
                                showFilterMatchModes={false}
                                showFilterMenuOptions={false}
                                filterClear={filterClearTemplate}
                                filterApply={filterApplyTemplate}
                                filterField="timeEnd"
                                filterElement={dateEndFilterTemplate}
                            />
                        </DataTable>
                        <Paginator
                            first={first}
                            rows={paginationSize}
                            totalRecords={totalItems}
                            rowsPerPageOptions={[5, 10, 15, 25, 50]}
                            onPageChange={onPageChange}
                            className="border-top-1 border-bottom-1"
                            template="PrevPageLink PageLinks NextPageLink RowsPerPageDropdown"
                        />
                    </div>
                    {selectedRowData && (
                        <>
                            {windowWidth > 1248 && <div className={classNames('card widget-table col-12 md:col-12 mt-4 align-self-start sticky top-0')}>
                                <StatusesByPeriodDetails setSelectedRowData={setSelectedRowData}
                                                         setSelectedRowExpansion={setSelectedRowExpansion}
                                                         selectedRowData={selectedRowData}
                                />
                            </div>}

                            {windowWidth <= 1248 && <div>
                                <Dialog visible={visible}
                                        header={selectedRowData?.userName || 'Деталі статусу'}
                                        className="monitoring-info" onHide={() => setVisible(false)}>
                                    <StatusesByPeriodDetails setSelectedRowData={setSelectedRowData}
                                                             setSelectedRowExpansion={setSelectedRowExpansion}
                                                             selectedRowData={selectedRowData}
                                    />
                                </Dialog>
                            </div>}
                        </>
                    )}
                </div>
            </div>
            <BranchDialog/>
        </div>
    );
};

export default StatusesByPeriodList;
